import { ConsultationMedicalHistoryKey } from '@models/consultation-medical-history-key';
import { ExternalData } from '@models/dynamic-forms/external-data';
import { Question } from '@models/dynamic-forms/question';

export class MedicalHistoryQuestion extends Question {
  public consultationRequestKey: ConsultationMedicalHistoryKey | null;
  public answerOverrideQuestionId: string | null;
  public includeQuestionLabel: boolean;

  public constructor(
    options: ConstructorParameters<typeof Question>[0],
    consultationRequestKey: ConsultationMedicalHistoryKey | null = null,
    answerOverrideQuestionId: string | null = null,
    includeQuestionLabel: boolean = true,
    externalData?: ExternalData,
  ) {
    super(options, externalData);
    this.consultationRequestKey = consultationRequestKey;
    this.answerOverrideQuestionId = answerOverrideQuestionId;
    this.includeQuestionLabel = includeQuestionLabel;
  }
}
